import {FirestoreDocSnapshotWithIdAndData} from '@coolcolduk/firebase-util';
import {mapFirestoreDocWithTimestamp} from '../_other/firestore';
import {TradeDb} from './tradeDbSchema';
import {Trade, tradeSchema} from './tradeSchema';

export function mapTradeDbToType(db: FirestoreDocSnapshotWithIdAndData<TradeDb>): Trade {
  const data = mapFirestoreDocWithTimestamp(db);
  return tradeSchema.parse(data);
}
